import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { replace } from 'connected-react-router'

import { storeAccessToken } from '../../../services/data/accessToken'

import { withFirebase } from '../../../components/accessibility/Firebase/Firebase'

import { setDevice } from '../../../modules/device/actions/creators'

import {
  doAuthenticate,
  doAppleLogin,
  doGoogleLogin,
} from '../../../controllers/Login'

import {
  doGetFirebaseToken,
  doSubscribeToFirebaseMessaging,
  doSubscribeToFirebaseGuest,
} from '../../../controllers/Firebase'

import { setLoyaltyPoints } from '../../../modules/loyalty/actions/creators'
import { setPrimaryInfo } from '../../../modules/profile/actions/creators'
import {
  setStep,
  setGoogleToken,
  setAppleToken,
} from '../../../modules/registration/actions/creators'
import {
  setAccessToken,
  setFirebaseMessagingToken,
  setAuthRequestData,
  setLoginStep,
  setLoginRequestId,
} from '../../../modules/auth/actions/creators'

import MainView from '../components/MainView/MainView'

const saveAccessToken = accessToken => {
  storeAccessToken(accessToken)
  return {
    type: '',
    payload: {},
  }
}

const mapStateToProps = reduxState => {
  const { auth, device: deviceModule } = reduxState

  const { redirectAfterAuth, firebaseMessagingToken } = auth
  const { browser } = deviceModule

  return {
    redirectAfterAuth,
    firebaseMessagingToken,
    browser,
    doLogin: doAuthenticate,
    doGoogleLogin,
    doAppleLogin,
    doGetFirebaseToken,
    doSubscribeToFirebaseMessaging,
    doSubscribeToFirebaseGuest,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setDevice,
      setPrimaryInfo,
      setLoyaltyPoints,
      setStep,
      replace,
      setAccessToken,
      saveAccessToken,
      setGoogleToken,
      setAppleToken,
      setFirebaseMessagingToken,
      setAuthRequestData,
      setLoginStep,
      setLoginRequestId,
    },
    dispatch,
  )

const ConnectedMainView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFirebase(MainView))

export default ConnectedMainView
